import { render, staticRenderFns } from "./productProfit.vue?vue&type=template&id=6a47abc6"
import script from "./productProfit.vue?vue&type=script&lang=js"
export * from "./productProfit.vue?vue&type=script&lang=js"
import style0 from "./productProfit.vue?vue&type=style&index=0&id=6a47abc6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports